import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type LogUxpErrorSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type LogUxpErrorSubscription = { __typename?: 'Subscription', uxpRuntimeError: { __typename?: 'UxpRuntimeErrorPayload', id: string, message: string, operation?: string | null, severity: Types.ErrorSeverity, source: string, stack?: string | null, timestamp: string } };


export const LogUxpError = /*#__PURE__*/ gql`
    subscription LogUxpError {
  uxpRuntimeError {
    id
    message
    operation
    severity
    source
    stack
    timestamp
  }
}
    ` as unknown as DocumentNode<LogUxpErrorSubscription, LogUxpErrorSubscriptionVariables>;

          

          export const useLogUxpErrorSubscription = (options?:SubscriptionHookOptions<LogUxpErrorSubscription, LogUxpErrorSubscriptionVariables>) => useSubscription(LogUxpError, options);

          

          export type LogUxpErrorSubscriptionOptions = SubscriptionHookOptions<LogUxpErrorSubscription, LogUxpErrorSubscriptionVariables>;

          

          export type LogUxpErrorSubscriptionResult = ReturnType<typeof useLogUxpErrorSubscription>;

          
